<template>
  <section
    v-if="ourDifference"
    class="ourDifference"
    :class="[ourDifference.parentClasses, ourDifference.parentStyle ? ourDifference.parentStyle : 'defaultStyle']"
  >
    <div class="container col">
      <div class="row">
        <div
          v-for="item in ourDifference.items"
          :key="item"
          class="ourDifference__item col"
          :class="item.classes ? item.classes : 's12 m6'"
        >
          <strong
            v-if="item.label"
            class="label primary-color-text text-base-1"
            v-html="item.label"
          ></strong>
          <h2
            v-if="item.title"
            class="title"
            v-html="item.title"
          ></h2>
          <h4
            v-if="item.subTitle"
            v-html="item.subTitle"
          ></h4>
          <div
            v-if="item.descr"
            v-html="item.descr"
          ></div>

          <div
            v-if="item.video && item.videoPreview"
            class="video-container"
            @click="loadYoutube(item.video)"
          >
            <nuxt-picture
              v-if="!playingVideo"
              :img-attrs="{alt: item.title}"
              :src="item.videoPreview"
              sizes="sm:100vw"
              :loading="props.indexComponent === 0 ? 'eager' : 'lazy'"
              height="380"
              width="670"
            />

            <button
              v-if="!playingVideo"
              class="play"
              aria-label="Play"
            >
              <svg
                height="100%"
                version="1.1"
                viewBox="0 0 68 48"
                width="100%"
              ><path
                class="youtube-play"
                d="M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z"
                fill="#212121"
                fill-opacity="0.8"
              ></path><path
                d="M 45,24 27,14 27,34"
                fill="#fff"
              ></path></svg>
            </button>

            <div
              class="youtube"
              :data-difference-id="item.video"
            ></div>
          </div>

          <div
            v-else
            class="content-block"
          >
            <div
              v-if="item.content"
              v-html="item.content"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
const { confWidgets } = useConfig()

const playingVideo = ref(false)

/**
* Props
*/
const props = defineProps({
  data: {
    type: [Object],
    default: null
  },
  indexComponent: {
    type: [Number],
    default: null
  }
})

/**
* Default Fields
*/
let ourDifference = {}
if (props.data) {
  ourDifference = props.data
  if (!props.data.customFields) {
    ourDifference.items = confWidgets.PagesOurDifference.data.items ? confWidgets.PagesOurDifference.data.items : []
  }
}

/**
* Load Youtube
*/
const loadYoutube = (id) => {
  playingVideo.value = true
  document.querySelector(`[data-difference-id="${id}"]`).innerHTML = `<iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/${id}?autoplay=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
}
</script>

<style lang="scss" scoped>
.ourDifference {
  &__item {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  .video-text {
    display: flex;
    align-items: center;
    &-content {
      @media only screen and (max-width: 600px) {
        padding: 2rem 0 0 0;
      }
    }
  }
}
</style>
